class CartFooter extends HTMLElement {
  constructor() {
    super();
    this.termsCheckbox = this.querySelector('[data-cart-terms]');
    this.checkoutButton = this.querySelector('[data-action="checkout"]');
    this.clearButton = this.querySelector('[data-action="clear-cart"]');
    this.requireTerms = this.dataset.requireTerms === 'true';
  }

  connectedCallback() {
    this._abortController = new AbortController();
    this.attachEvents();
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  attachEvents() {
    const signal = this._abortController.signal;
    this.termsCheckbox?.addEventListener('change', this.handleTermsChange.bind(this), { signal });
    const checkoutForm = document.getElementById(this.dataset.checkoutFormId);
    checkoutForm?.addEventListener('submit', this.handleFormSubmit.bind(this), { signal });
    this.clearButton?.addEventListener('click', this.handleClearCart.bind(this), { signal });
  }

  handleTermsChange() {
    if (!this.shouldValidateTerms()) return;

    const isChecked = this.termsCheckbox.checked;
    this.getCheckoutButtons().forEach((button) => { button.disabled = !isChecked; });
  }

  getCheckoutButtons() {
    const formId = this.dataset.checkoutFormId;
    if (!formId) return [this.checkoutButton];

    return Array.from(document.querySelectorAll(`[data-action="checkout"][form="${formId}"]`));
  }

  shouldValidateTerms() {
    return this.requireTerms && this.termsCheckbox && this.checkoutButton;
  }

  handleFormSubmit(event) {
    if (this.shouldBlockCheckout()) {
      event.preventDefault();
    }
  }

  shouldBlockCheckout() {
    return this.requireTerms && this.termsCheckbox && !this.termsCheckbox.checked;
  }

  async handleClearCart(event) {
    event.preventDefault();

    if (!this.confirmClearCart()) return;

    theme.cart.errors.clearFooter();
    theme.cart.errors.eachLine((key) => theme.cart.errors.clearLine(key));

    const footerSlot = this.querySelector('[data-cart-footer-error]');
    if (footerSlot) { footerSlot.hidden = true; footerSlot.textContent = ''; }

    this.setLoading(true);

    try {
      await theme.cart.clear();
    } catch (error) {
      this.setLoading(false);
    }
  }

  confirmClearCart() {
    return confirm(this.dataset.clearConfirm);
  }

  setLoading(isLoading) {
    const buttons = this.querySelectorAll('button');

    buttons.forEach((button) => {
      button.disabled = isLoading;
    });

    this.style.opacity = isLoading ? '0.6' : '1';
    this.style.pointerEvents = isLoading ? 'none' : '';
  }
}

customElements.define('cart-footer', CartFooter);
